"use client"
import { usePanelTitleHandler } from '@/hooks'
import { breadCrumbSelector } from '@/store'
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useSelector } from 'react-redux'



export default function BreadCrumb() {
    const location = usePathname();
    let { data } = useSelector((store) => breadCrumbSelector(store)) || {}
    const formattedSlug = location.slice(1).split("-").join("_")
    const { breadCrumb, PANEL_TITLES } = usePanelTitleHandler({ sectionName: formattedSlug });
    const titles_keys = Object.keys(PANEL_TITLES)
    if (titles_keys.includes(formattedSlug)) {
        data = [{
            text: breadCrumb,
            slug: `${location}`
        }]
    }
    if (location == '/') return null

    return (
        <div className='max-w-[1920px] mx-auto'>
            <div className='absolute h-24 z-9'>
                <nav className="flex pl-6 items-center h-full" aria-label="Breadcrumb">
                    <ol role="list" className="flex items-center space-x-4">
                        <li>
                            <div>
                                <Link href="/" className="text-gray-400 hover:text-gray-500">
                                    <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                    <span className="sr-only">Home</span>
                                </Link>
                            </div>
                        </li>
                        {data.map((link, i) => (
                            <li key={i}>
                                <div className="flex items-center">
                                    <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                    <Link
                                        href={link.slug}
                                        className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    >
                                        {link.text}
                                    </Link>
                                </div>
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
        </div>

    )
}
